export function isTouchDevice() {
  const regexp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
  return window.navigator.userAgent.search(regexp) !== -1
}

export function getStripePublicKey(): any {
  const element: any = document.querySelector('meta[name=stripe-public-key]')

  return element ? element.content : ''
}
